{
  "familyId": "TGL-GELD-BTW",
  "questions": [
    {
      "id": "TGL-GELD-BTW-001",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verkoopt een fietsband voor €100 exclusief BTW. Met 21% BTW erbij, wat betaalt de klant?",
      "options": ["€121", "€21", "€79", "€100,21"],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (21%)",
            "content": "Bereken eerst de BTW: 21% van €100 = 0,21 × €100 = €21. Tel de BTW bij de prijs: €100 + €21 = €121. De klant betaalt €121.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De fietsenmaker berekent de prijs inclusief BTW: 21% van €100 = €21. Totaal: €100 + €21 = €121. Of sneller: €100 × 1,21 = €121.",
        "solutionSteps": [
          "BTW = 21% van €100 = 0,21 × €100 = €21",
          "Prijs inclusief = €100 + €21 = €121",
          "Of sneller: €100 × 1,21 = €121 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €100 + 21% BTW (€21) = €121.",
          "1": "Je dacht waarschijnlijk dat €21 het eindantwoord is. Maar €21 is alleen het BTW-bedrag. De klant betaalt de prijs plus de BTW: €100 + €21 = €121. Onthoud: inclusief BTW = prijs + BTW-bedrag.",
          "2": "Je dacht waarschijnlijk dat je de BTW aftrekt. Maar bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €100 + €21 = €121, niet €100 − €21 = €79. Onthoud: inclusief = erbij optellen.",
          "3": "Je dacht waarschijnlijk dat 21% gelijk is aan €0,21. Maar 21% betekent 0,21 × de prijs. 0,21 × €100 = €21, niet €0,21. Onthoud: een percentage is een deel van het geheel."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-002",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een bloemist koopt bloemen voor €50 exclusief BTW. Met 9% BTW erbij, wat betaalt ze?",
      "options": ["€54,50", "€4,50", "€45,50", "€59"],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (9%)",
            "content": "Bereken eerst de BTW: 9% van €50 = 0,09 × €50 = €4,50. Tel de BTW bij de prijs: €50 + €4,50 = €54,50.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De bloemist berekent de prijs inclusief BTW: 9% van €50 = €4,50. Totaal: €50 + €4,50 = €54,50. Of sneller: €50 × 1,09 = €54,50.",
        "solutionSteps": [
          "BTW = 9% van €50 = 0,09 × €50 = €4,50",
          "Prijs inclusief = €50 + €4,50 = €54,50",
          "Of sneller: €50 × 1,09 = €54,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €50 + 9% BTW (€4,50) = €54,50.",
          "1": "Je dacht waarschijnlijk dat €4,50 het eindantwoord is. Maar €4,50 is alleen het BTW-bedrag. De bloemist betaalt de prijs plus de BTW: €50 + €4,50 = €54,50. Onthoud: inclusief = prijs + BTW.",
          "2": "Je dacht waarschijnlijk dat je de BTW aftrekt. Maar bij 'inclusief BTW' tel je de BTW erbij op: €50 + €4,50 = €54,50, niet €50 − €4,50 = €45,50. Onthoud: inclusief = erbij optellen.",
          "3": "Je dacht waarschijnlijk dat 9% gelijk is aan €9. Maar 9% van €50 is €4,50, niet €9. Onthoud: 0,09 × €50 = €4,50."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-003",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een elektricien stuurt een rekening van €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€100", "€96,80", "€142", "€101"],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (21%)",
            "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €121 ÷ 1,21 = €100.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De klant wil weten wat de elektricien exclusief BTW rekent. Bij 21% BTW deel je door 1,21: €121 ÷ 1,21 = €100. Controleer: €100 × 1,21 = €121 ✓.",
        "solutionSteps": [
          "21% BTW → deel door 1,21",
          "€121 ÷ 1,21 = €100",
          "Controleer: €100 × 1,21 = €121 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €121 ÷ 1,21 = €100.",
          "1": "Je dacht waarschijnlijk dat je 21% van €121 aftrekt: 21% van €121 = €25,41, dus €121 − €25,41 ≈ €95,59 ≈ €96,80. Maar 21% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,21.",
          "2": "Je dacht waarschijnlijk dat je 21% moet optellen. Maar bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Onthoud: inclusief → exclusief = delen door 1,21.",
          "3": "Je dacht waarschijnlijk dat je €121 − €21 = €101 kunt rekenen. Maar €21 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,21."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-004",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een bakker koopt meel voor €200 exclusief BTW. Hoeveel BTW betaalt hij bij 21%?",
      "options": ["€42", "€21", "€158", "€242"],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €200: 0,21 × €200 = €42. De bakker betaalt €42 aan BTW.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De bakker berekent de BTW: 21% van €200 = 0,21 × €200 = €42. Hij betaalt €42 aan BTW.",
        "solutionSteps": [
          "BTW = 21% van €200",
          "BTW = 0,21 × €200 = €42"
        ],
        "distractorExplanations": {
          "0": "Goed! 21% van €200 = €42 aan BTW.",
          "1": "Je dacht waarschijnlijk dat 21% altijd €21 is. Maar 21% hangt af van het bedrag: 0,21 × €200 = €42. Onthoud: 21% van €100 = €21, maar 21% van €200 = €42.",
          "2": "Je verwart de prijs na aftrek met het BTW-bedrag. €158 = €200 − €42, maar de vraag is hoeveel BTW de bakker betaalt: €42. Onthoud: BTW = percentage × prijs.",
          "3": "Je verwart de totaalprijs met het BTW-bedrag. €242 = €200 + €42 (de totaalprijs inclusief BTW). De vraag is alleen hoeveel BTW: €42."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-005",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een restauranthouder betaalt €54,50 inclusief 9% BTW voor ingrediënten. Wat is de prijs exclusief BTW?",
      "options": ["€50", "€49,60", "€59,40", "€45,50"],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €54,50 ÷ 1,09 = €50.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De restauranthouder deelt door 1,09: €54,50 ÷ 1,09 = €50. Controleer: €50 × 1,09 = €54,50 ✓.",
        "solutionSteps": [
          "9% BTW → deel door 1,09",
          "€54,50 ÷ 1,09 = €50",
          "Controleer: €50 × 1,09 = €54,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €54,50 ÷ 1,09 = €50.",
          "1": "Je dacht waarschijnlijk dat je 9% van €54,50 aftrekt: €54,50 − €4,91 = €49,59 ≈ €49,60. Maar 9% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,09.",
          "2": "Je dacht waarschijnlijk dat je 9% moet optellen. Maar bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Onthoud: inclusief → exclusief = delen door 1,09.",
          "3": "Je dacht waarschijnlijk dat je €54,50 − €9 = €45,50 kunt rekenen. Maar €9 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,09."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-006",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een schilder koopt verf voor €150 exclusief BTW. Met 21% BTW erbij, wat betaalt hij?",
      "options": ["€181,50", "€31,50", "€118,50", "€171"],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct_large",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (21%)",
            "content": "Bereken eerst de BTW: 21% van €150 = 0,21 × €150 = €31,50. Tel de BTW bij de prijs: €150 + €31,50 = €181,50.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De schilder berekent de prijs inclusief BTW: 21% van €150 = €31,50. Totaal: €150 + €31,50 = €181,50. Of sneller: €150 × 1,21 = €181,50.",
        "solutionSteps": [
          "BTW = 21% van €150 = 0,21 × €150 = €31,50",
          "Prijs inclusief = €150 + €31,50 = €181,50",
          "Of sneller: €150 × 1,21 = €181,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €150 + 21% BTW (€31,50) = €181,50.",
          "1": "Je dacht waarschijnlijk dat €31,50 het eindantwoord is. Maar €31,50 is alleen het BTW-bedrag. De schilder betaalt de prijs plus de BTW: €150 + €31,50 = €181,50. Onthoud: inclusief = prijs + BTW.",
          "2": "Je dacht waarschijnlijk dat je de BTW aftrekt. Maar bij 'inclusief BTW' tel je de BTW erbij op: €150 + €31,50 = €181,50, niet €150 − €31,50 = €118,50. Onthoud: inclusief = erbij optellen.",
          "3": "Je dacht waarschijnlijk dat 21% gelijk is aan €21. Maar 21% van €150 is €31,50, niet €21. Onthoud: 0,21 × €150 = €31,50."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-007",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een glazenwasser stuurt een rekening van €80 exclusief BTW. Hoeveel BTW betaalt de klant bij 21%?",
      "options": ["€16,80", "€21", "€63,20", "€96,80"],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_80",
      "variantIndex": 7,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €80: 0,21 × €80 = €16,80. De klant betaalt €16,80 aan BTW.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De klant van de glazenwasser berekent de BTW: 21% van €80 = 0,21 × €80 = €16,80.",
        "solutionSteps": [
          "BTW = 21% van €80",
          "BTW = 0,21 × €80 = €16,80"
        ],
        "distractorExplanations": {
          "0": "Goed! 21% van €80 = €16,80 aan BTW.",
          "1": "Je dacht waarschijnlijk dat 21% altijd €21 is. Maar 21% hangt af van het bedrag: 0,21 × €80 = €16,80. Onthoud: 21% van €100 = €21, maar 21% van €80 = €16,80.",
          "2": "Je verwart de prijs na aftrek met het BTW-bedrag. €63,20 = €80 − €16,80, maar de vraag is hoeveel BTW: €16,80. Onthoud: BTW = percentage × prijs.",
          "3": "Je verwart de totaalprijs met het BTW-bedrag. €96,80 = €80 + €16,80 (de totaalprijs inclusief BTW). De vraag is alleen hoeveel BTW: €16,80."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-008",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een meubelmaker verkoopt een kast voor €242 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€200", "€191,60", "€263", "€221"],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct_large",
      "variantIndex": 8,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.71,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (21%)",
            "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €242 ÷ 1,21 = €200.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De klant wil weten wat de kast exclusief BTW kost. Bij 21% BTW deel je door 1,21: €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242 ✓.",
        "solutionSteps": [
          "21% BTW → deel door 1,21",
          "€242 ÷ 1,21 = €200",
          "Controleer: €200 × 1,21 = €242 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €242 ÷ 1,21 = €200.",
          "1": "Je dacht waarschijnlijk dat je 21% van €242 aftrekt: €242 − €50,82 ≈ €191,18 ≈ €191,60. Maar 21% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,21.",
          "2": "Je dacht waarschijnlijk dat je 21% moet optellen. Maar bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Onthoud: inclusief → exclusief = delen door 1,21.",
          "3": "Je dacht waarschijnlijk dat je €242 − €21 = €221 kunt rekenen. Maar €21 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,21."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-009",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een boekhandelaar koopt boeken voor €40 exclusief BTW. Met 9% BTW erbij, wat betaalt ze?",
      "options": ["€43,60", "€3,60", "€36,40", "€49"],
      "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct_40",
      "variantIndex": 9,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW berekenen (9%)",
            "content": "Bereken eerst de BTW: 9% van €40 = 0,09 × €40 = €3,60. Tel de BTW bij de prijs: €40 + €3,60 = €43,60.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De boekhandelaar berekent de prijs inclusief BTW: 9% van €40 = €3,60. Totaal: €40 + €3,60 = €43,60. Of sneller: €40 × 1,09 = €43,60.",
        "solutionSteps": [
          "BTW = 9% van €40 = 0,09 × €40 = €3,60",
          "Prijs inclusief = €40 + €3,60 = €43,60",
          "Of sneller: €40 × 1,09 = €43,60 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €40 + 9% BTW (€3,60) = €43,60.",
          "1": "Je dacht waarschijnlijk dat €3,60 het eindantwoord is. Maar €3,60 is alleen het BTW-bedrag. De boekhandelaar betaalt de prijs plus de BTW: €40 + €3,60 = €43,60. Onthoud: inclusief = prijs + BTW.",
          "2": "Je dacht waarschijnlijk dat je de BTW aftrekt. Maar bij 'inclusief BTW' tel je de BTW erbij op: €40 + €3,60 = €43,60, niet €40 − €3,60 = €36,40. Onthoud: inclusief = erbij optellen.",
          "3": "Je dacht waarschijnlijk dat 9% gelijk is aan €9. Maar 9% van €40 is €3,60, niet €9. Onthoud: 0,09 × €40 = €3,60."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-010",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een kapper betaalt €109 inclusief 9% BTW voor haarverzorgingsproducten. Wat is de prijs exclusief BTW?",
      "options": ["€100", "€99,20", "€118", "€90"],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_109",
      "variantIndex": 10,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €109 ÷ 1,09 = €100.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De kapper deelt door 1,09: €109 ÷ 1,09 = €100. Controleer: €100 × 1,09 = €109 ✓.",
        "solutionSteps": [
          "9% BTW → deel door 1,09",
          "€109 ÷ 1,09 = €100",
          "Controleer: €100 × 1,09 = €109 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €109 ÷ 1,09 = €100.",
          "1": "Je dacht waarschijnlijk dat je 9% van €109 aftrekt: €109 − €9,81 ≈ €99,19 ≈ €99,20. Maar 9% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,09.",
          "2": "Je dacht waarschijnlijk dat je 9% moet optellen. Maar bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Onthoud: inclusief → exclusief = delen door 1,09.",
          "3": "Je dacht waarschijnlijk dat je €109 − €19 = €90 kunt rekenen. Maar 9% van €109 is niet €19. Onthoud: deel door 1,09."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-011",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een ICT-bedrijf koopt een laptop voor €500 exclusief BTW. Hoeveel BTW betalen ze bij 21%?",
      "options": ["€105", "€21", "€395", "€605"],
      "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_500",
      "variantIndex": 11,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Bereken 21% van €500: 0,21 × €500 = €105. Het bedrijf betaalt €105 aan BTW.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "Het ICT-bedrijf berekent de BTW: 21% van €500 = 0,21 × €500 = €105.",
        "solutionSteps": [
          "BTW = 21% van €500",
          "BTW = 0,21 × €500 = €105"
        ],
        "distractorExplanations": {
          "0": "Goed! 21% van €500 = €105 aan BTW.",
          "1": "Je dacht waarschijnlijk dat 21% altijd €21 is. Maar 21% hangt af van het bedrag: 0,21 × €500 = €105. Onthoud: 21% van €100 = €21, maar 21% van €500 = €105.",
          "2": "Je verwart de prijs na aftrek met het BTW-bedrag. €395 = €500 − €105, maar de vraag is hoeveel BTW: €105. Onthoud: BTW = percentage × prijs.",
          "3": "Je verwart de totaalprijs met het BTW-bedrag. €605 = €500 + €105 (de totaalprijs inclusief BTW). De vraag is alleen hoeveel BTW: €105."
        }
      }
    },
    {
      "id": "TGL-GELD-BTW-012",
      "familyId": "TGL-GELD-BTW",
      "module": "TijdGeld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "multiple_choice",
      "question": "Een loodgieter stuurt een rekening van €87,20 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€80", "€79,35", "€95,05", "€78,20"],
      "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_87",
      "variantIndex": 12,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "BTW terugrekenen (9%)",
            "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €87,20 ÷ 1,09 = €80.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De klant van de loodgieter deelt door 1,09: €87,20 ÷ 1,09 = €80. Controleer: €80 × 1,09 = €87,20 ✓.",
        "solutionSteps": [
          "9% BTW → deel door 1,09",
          "€87,20 ÷ 1,09 = €80",
          "Controleer: €80 × 1,09 = €87,20 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €87,20 ÷ 1,09 = €80.",
          "1": "Je dacht waarschijnlijk dat je 9% van €87,20 aftrekt: €87,20 − €7,85 = €79,35. Maar 9% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,09.",
          "2": "Je dacht waarschijnlijk dat je 9% moet optellen. Maar bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Onthoud: inclusief → exclusief = delen door 1,09.",
          "3": "Je dacht waarschijnlijk dat je €87,20 − €9 = €78,20 kunt rekenen. Maar 9% van €87,20 is niet €9. Onthoud: deel door 1,09."
        }
      }
    }
  ]
}